import React from "react";
import { Route, Routes } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ROUTES, ROUTES_LINKS } from "../../routes/routes";
import ClientsOrders from "./ClientsOrders";
import CreateProduct from "./CreateProduct";
import CrudProducts from "./CrudProducts";
import EditProduct from "./EditProduct";
import StoreGraphes from "./StoreGraphes";
import MainSearchBar from "../user/Search/MainSearchBar";
import "./MainAdminPage.css";
import { useStore } from "../../context/store.provider";
import { updateDB } from "../user/GettingData/firebase";
import Inventory from "./Inventory";
import { logoURL } from "../../assets/images/logourl";
import { algoritemPrice } from "./algoritem";
import List from "./List";
import GiftCards from "./GiftCards";
// here need to show the whole products with the search opion that under every card there is buttons edit and delete
// and on the right side there is create this will be open a form that on submit need to creat the element inside the mokeApi
function MainAdminPage() {
  const navigate = useNavigate();
  const { storeProducts } = useStore();
  const onClickGraphes = () => {
    navigate(ROUTES_LINKS.TO_STORE_GRAPHES);
  };
  const onClickOrders = () => {
    navigate(ROUTES_LINKS.TO_CLIENT_ORDERS);
  };
  const onClickCreate = () => {
    navigate(ROUTES_LINKS.TO_CREATE_PRODUCT);
  };
  const handleNavigationToUserStore = () => {
    navigate(ROUTES_LINKS.TO_STORE);
  };
  const onClickInventory = () => {
    navigate(ROUTES_LINKS.TO_INVENTORY);
  };
  const onClickList = () => {
    navigate(ROUTES_LINKS.TO_LIST);
  };
  const onClickGiftCards = () => {
    navigate(ROUTES_LINKS.TO_GIFT_CARDS);
  };
  const updateAll = () => {
    const storePrice =[]
    // storeProducts.forEach((product) => {
    //   storePrice.push(product.storePrice)
    //   // console.log(product.price)
    //   // console.log(product.storePrice)
    //   // if (typeof product.storePrice=== "string") {
    //   //   // const price = algoritemPrice(product.storePrice);
    //   //   console.log(product.price);
    //   //   const NewProduct = {
    //   //     productName: product.productName,
    //   //     category: product.category,
    //   //     imgUrl: product.imgUrl,
    //   //     quantity: product.quantity ? Number(product.quantity) : null,
    //   //     storePrice: Number(product.storePrice),
    //   //     price:product.price,
    //   //     id: product.id,
    //   //     salePrice: product.salePrice ? product.salePrice : null,
    //   //     edited: true,
    //   //   };
    //   //   // console.log(NewProduct);
    //   //   const identifier = product.id - 1;
    //   //   console.log(identifier);
    //   //   // updateDB(NewProduct, identifier);
    //   // }
    // });

  };
const onClickSales =(e)=>{
  console.log(e);
}
  return (
    <>
      <Routes>
        <Route
          path={ROUTES.ROOT}
          element={
            <>
              <div className="nav-bar-admin">
                <div className="btns-container">
                  <button onClick={onClickList}>רשימת מוצרים ללא תמונות</button>
                  <button onClick={onClickGiftCards}>כרטיסי מתנה</button>
                  <button onClick={onClickInventory}>Inventory</button>
                  <button onClick={onClickGraphes}>
                    <i className="fa-solid fa-chart-line"></i> Data graphes
                  </button>
                  <button onClick={onClickOrders}>
                    <i className="fa-solid fa-bell"></i>
            client orders
                  </button>
                  <button onClick={onClickCreate}>
                    <i className="fa-solid fa-circle-plus"></i> create new
                    product
                  </button>
                  <button onClick={onClickSales}>יצירת מבצעים חדשים</button>
                </div>
                <MainSearchBar />
                <button onClick={handleNavigationToUserStore}>
                  <i className="fa-solid fa-backward"></i>
                  <i className="fa-solid fa-store"></i> חזרה לחנות של צרכן{" "}
                </button>
              </div>
              <div className="red-admin"></div>
              <CrudProducts />
            </>
          }
        />
        <Route path={ROUTES.STORE_GRAPHES} element={<StoreGraphes />} />
        <Route path={ROUTES.CLIENT_ORDERS} element={<ClientsOrders />} />
        <Route path={ROUTES.CREATE_PRODUCT} element={<CreateProduct />} />
        <Route path={ROUTES.EDIT_PRODUCT} element={<EditProduct />} />
        <Route path={ROUTES.INVENTORY} element={<Inventory />} />
        <Route path={ROUTES.LIST} element={<List />} />
        <Route path={ROUTES.GIFT_CARDS} element={<GiftCards />} />
      </Routes>
    </>
  );
}

export default MainAdminPage;
